module.exports = __webpack_public_path__ + "static/img/222.392ce62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/222.png
// module id = XboF
// module chunks = 0